import numeral from 'numeral';

const DEFAULT_NUMERAL_FORMAT: string = '0.[0]a';

/**
 * Shortens large numbers by using magnitude notation.
 * Internally, it uses the numeral.js to handle the formatting
 * e.g. 10,000 becomes 10k; 10,000,000,000,000 becomes 10t
 *
 * @param num
 * @param format the numeral.js supported format
 * @return string
 */
export const magnitudeFormatter = (num: number, format: string = DEFAULT_NUMERAL_FORMAT): string =>
  numeral(num).format(format);
